import {AbstractField} from "@domain/travel/abstract-field";

/**
 * Représente le paramétrage d'un trip field
 *
 * @author Laurent Convert
 * @date 20/11/2023
 */
export class TripField extends AbstractField {
	idTripField: number;

	constructor(dto?: TripField | any) {
		super(dto);
	}
}